import React from "react";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../../context/ContextProvider";

const LanguageToggle = ({ redirect }) => {
    const {
        langCode,
        changeLanguage,
        langs,
        isLangRTL,
        i18n
    } = useStateContext();

    const navigate = useNavigate();
    const otherLang = langs.find((lang) => lang.code !== langCode);

    const handleToggle = () => {
        if (!otherLang) return;

        changeLanguage(otherLang.code);

        if (redirect) {
            const currentParams = window.location.search;
            let redirectUrl;

            if (typeof redirect === "string") {
                redirectUrl = `${redirect}${currentParams}`;
            } else if (typeof redirect === "object" && redirect[otherLang.code]) {
                redirectUrl = `${redirect[otherLang.code]}${currentParams}`;
            } else {
                redirectUrl = `${window.location.pathname}${currentParams}`;
            }
            navigate(redirectUrl);
        }
    };

    if (!otherLang) return null;

    return (
        <div
            className={`text-white text-sm cursor-pointer`}
            style={{ zIndex: 10 }}
            onClick={handleToggle}
        >
            <div className="flex items-center gap-1 my-2">
                <img
                    src={otherLang?.flag}
                    alt={`${otherLang?.title} flag`}
                    className="inline-block w-4 h-3 border"
                />
                <div className="uppercase text-white">
                    {otherLang?.code}
                </div>
            </div>
        </div>
    );
};

export default LanguageToggle;